export const SHERBERT_ASSETS_API_URL_V3 = "https://api.sherbert.cimpress.io/v3/assets";
export const SHERBERT_ASSETS_API_URL_V2 = "https://api.sherbert.cimpress.io/v2/assets";
export const SHERBERT_ASSETS_CDN_URL_V3 = "https://cdn-api.sherbert.cimpress.io/v3/assets";
export const SHERBERT_ASSETS_CDN_URL_V2 = "https://cdn-api.sherbert.cimpress.io/v2/assets";
